/*eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';

import authenticationStore from './authenticate'
import AlgorithmStore from './algorithm'
import DataWellStore from './dataWell'
import AccountStore from './suAccount'
import SuperAdminAccountStore from './saAccount'
import TaskStore from './task'
import ChatBot from './chatBot'
import Profile from './profile'
import UserStore from './userStore'
import VideoStore from './videoStore'
export const strict = false
Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    authenticationStore,
    AlgorithmStore,
    DataWellStore,
    AccountStore,
    TaskStore,
    SuperAdminAccountStore,
    ChatBot,
    Profile,
    UserStore,
    VideoStore
  }
})